import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

interface AddRoleModalProps {
  onClose: () => void
  onSubmit: () => void
  disableSubmitButton: () => boolean
  disabledEmployeeIds: number[]
  onSelectEmployees: (state: EmployeeSelectorV2MultiSelectState) => void
  buttonCentered?: boolean
}

const AddRoleModal = ({
  onClose,
  onSubmit,
  disableSubmitButton,
  disabledEmployeeIds,
  onSelectEmployees,
  buttonCentered,
}: AddRoleModalProps) => {
  const [openModal, setOpenModal] = useState<boolean>(false)

  const onCloseModal = () => {
    setOpenModal(false)
    onClose()
  }

  const onSubmitModal = () => {
    onSubmit()
    setOpenModal(false)
  }

  return (
    <>
      <Box paddingTop="s24" alignItems={buttonCentered ? 'center' : 'baseline'}>
        <Button iconName="add" type={'secondary'} onClick={() => setOpenModal(true)}>
          {i18n.t('common.add')}
        </Button>
      </Box>
      {openModal && (
        <Modal
          illustration={'add-user'}
          title={i18n.t('project_management.settings.sections.project_roles.modal.title')}
          onClose={onCloseModal}
          onSubmit={onSubmitModal}
          disableFocusTrap
          footer={
            <>
              <Button type="secondary" onClick={onCloseModal}>
                {i18n.t('common.cancel')}
              </Button>
              <Button disabled={disableSubmitButton()} submit>
                {i18n.t('common.add')}
              </Button>
            </>
          }
        >
          <Box padding="s16">
            <EmployeeSelectorV2
              multiple
              forcedFilters={{ excludeCurrentEmployee: true, excludeIds: disabledEmployeeIds }}
              options={{ asList: true }}
              onChange={onSelectEmployees}
            />
          </Box>
        </Modal>
      )}
    </>
  )
}

export default AddRoleModal
